<template>
    <div class="wrapper">
        <p class="title">{{ $t("userAMLQuestionnaire.fifthStep.labelOne") }}</p>
        <p class="description">
            <span>{{ $t("userAMLQuestionnaire.fifthStep.labelTwo") }}</span>
            <span class="description__button"
                @click="openPEPModal"
            >{{ $t("userAMLQuestionnaire.fifthStep.learnMore") }}</span>
        </p>

        <div class="options-wrapper flex">
            <div v-for="(option,index) in options"
                :key="index"
            >
                <div class="option">
                    <div
                        class="option__circle"
                        :automationText="`pep-option-${index}`"
                        @click="toggleOption(index)"
                    />
                    <div v-if="option.checked"
                        class="option__circle--fill"
                    />
                </div>
                <label :for="index">{{ option.text }}</label>
            </div>
        </div>
    </div>
</template>

<script>
const NO_OPTION_INDEX = 0;
const YES_OPTION_INDEX = 1;

// Store
import {
    mapActions,
} from 'vuex';
import localStoreTypes from '@webapp/store/types.js';

export default {
    name: 'question-5',
    props: {
        isActive: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            options: [
                {
                    checked: false,
                    text: this.$t('userAMLQuestionnaire.fifthStep.optionTwo'),
                    value: false,
                },
                {
                    checked: false,
                    text: this.$t('userAMLQuestionnaire.fifthStep.optionOne'),
                    value: true,
                },
            ],
        };
    },
    computed: {
        selectedOptionIndex() {
            return this.options.findIndex((option) => option.checked);
        },
    },
    watch: {
        isActive() {
            const hasCheckedOption = this.options.some((option) => option.checked);

            if (!hasCheckedOption) {
                this.updateOptionsByIndex(NO_OPTION_INDEX);
            }
        },
    },
    methods: {
        ...mapActions({
            resetModal: localStoreTypes.RESET_MODAL,
            setModal: localStoreTypes.SET_MODAL,
        }),
        toggleOption(index) {
            switch (index) {
                case this.selectedOptionIndex:
                    break;
                case YES_OPTION_INDEX:
                    this.showWarningModal();
                    break;
                default:
                    this.updateOptionsByIndex(index);
                    break;
            }
        },
        updateOptionsByIndex(index) {
            this.options.forEach((opt) => {
                opt.checked = false;
            });

            this.options[index].checked = true;

            this.$emit('completed', {
                pep: this.options[index].value,
            });
        },
        resetStep() {
            window.setTimeout(() => {
                this.options.forEach((option) => {
                    option.checked = false;
                });
            }, 0);
        },
        showWarningModal() {
            this.setModal({
                isVisible: true,
                image: require('@webapp/assets/info.webp'),
                title: this.$t('userAMLQuestionnaire.fifthStep.modalTitle'),
                messages: [],
                acceptButton: {
                    text: this.$t('userAMLQuestionnaire.fifthStep.modalAcceptButton'),
                    action: () => this.onWarningModalAcceptButton(),
                },
                cancelButton: {
                    text: this.$t('userAMLQuestionnaire.fifthStep.modalCancelButton'),
                    action: () => this.onWarningModalCancelButton(),
                },
            });
        },
        onWarningModalCancelButton() {
            this.updateOptionsByIndex(YES_OPTION_INDEX);
            this.resetModal();
        },
        onWarningModalAcceptButton() {
            this.resetModal();
        },
        openPEPModal() {
            this.setModal({
                isVisible: true,
                componentToLoad: 'modules/customer-first/components/aml-questionnaire/pep-modal',
            });
        },
    },
};
</script>

<style lang="scss" scoped>
.wrapper {
    .title {
        font-size: 1.75rem;
        line-height: 23px;
    }

    .description {
        font-size: 1.65rem;
        font-weight: bold;
        margin-bottom: 30px;

        & > * {
            display: block;
        }

        &__button {
            color: $lima-color;
            cursor: pointer;
        }
    }

    .options-wrapper {
        input,
        label {
            font-size: 1.65rem;
        }

        > div {
            display: flex;
            margin-right: 24px;
        }

        .option {
            position: relative;

            .option__circle {
                height: 15px;
                width: 15px;
                margin-right: 5px;
                border: 1px solid $lima-color;
                border-radius: 50%;

                &--fill {
                    height: 11px;
                    width: 11px;
                    background-color: $lima-color;
                    border-radius: 50%;
                    position: absolute;
                    top: 3px;
                    left: 3px;
                }
            }
        }
    }
}
</style>